<template lang="pug">
.host-view-loader
  .container
    HostHeader
    ResponsiveHostGallery.gallery-placeholder.py-4
  HostSectionHeader.item-h1.mb-0 &nbsp;
  .container.py-4
    TextContentLoader(:lines="30" :min-line-length="95" randomize)
</template>

<script>
import HostHeader from "@/views/components/host/layout/HostHeader";
import ResponsiveHostGallery from "@/views/components/host/gallery/ResponsiveHostGallery";
import HostSectionHeader from "@/views/components/host/layout/HostSectionHeader";
import TextContentLoader from "@/views/components/partials/contentLoader/TextContentLoader";
export default {
  name: "HostViewLoader",
  components: {TextContentLoader, HostSectionHeader, ResponsiveHostGallery, HostHeader}
}
</script>
<style lang="scss" scoped>
.gallery-placeholder {
  pointer-events: none!important;
}
</style>
